var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import MUIContainer from '@mui/material/Container';
import useEmotionStyles from '../hooks/useEmotionStyles';
import { useMediaQueryOrBoolean, } from '../hooks/useMediaQueryOrBoolean';
var styles = function () { return ({
    colRoot: {
        '&.MuiGrid-grid-xs-0, &.MuiGrid-grid-sm-0, &.MuiGrid-grid-md-0, &.MuiGrid-grid-lg-0, &.MuiGrid-grid-xl-0': {
            paddingTop: 0,
        },
    },
}); };
export var Container = function (_a) {
    var children = _a.children, disableGutters = _a.disableGutters, restProps = __rest(_a, ["children", "disableGutters"]);
    var shouldDisableGutter = useMediaQueryOrBoolean(disableGutters, false);
    return (React.createElement(MUIContainer, __assign({ maxWidth: "xl", disableGutters: shouldDisableGutter }, restProps), children));
};
Container.displayName = 'GridContainer';
export var Row = function (_a) {
    var children = _a.children, _b = _a.spacing, spacing = _b === void 0 ? 1 : _b;
    return (React.createElement(Grid, { sx: { flexGrow: 1 }, container: true, spacing: spacing }, children));
};
Row.displayName = 'GridRow';
var OffsetCol = function (_a) {
    var offset = __rest(_a, []);
    var cs = useEmotionStyles(styles);
    var filledOffset = useMemo(function () {
        var isFilled = false;
        var bps = ['xs', 'sm', 'md', 'lg', 'xl'];
        var preparedOffset = __assign({}, offset);
        bps.forEach(function (bp) {
            if (isFilled) {
                return;
            }
            if (typeof preparedOffset[bp] !== 'undefined') {
                isFilled = true;
            }
            else {
                preparedOffset[bp] = 0;
            }
        });
        return preparedOffset;
    }, [offset.xs, offset.sm, offset.md, offset.lg, offset.xl]);
    return React.createElement(Grid, __assign({ item: true }, filledOffset, { className: cs.colRoot }));
};
export var Col = function (_a) {
    var children = _a.children, offset = _a.offset, order = _a.order, propsToPass = __rest(_a, ["children", "offset", "order"]);
    var computedSX = useMemo(function () { return (typeof order === 'undefined' ? undefined : { order: order }); }, [order]);
    return (React.createElement(React.Fragment, null,
        typeof offset !== 'undefined' && React.createElement(OffsetCol, __assign({}, offset)),
        React.createElement(Grid, __assign({ item: true, xs: 12 }, propsToPass, { sx: computedSX }), children)));
};
Col.displayName = 'GridCol';
